import { render, staticRenderFns } from "./ModalSubmitClaim.vue?vue&type=template&id=3f83e80f&"
import script from "./ModalSubmitClaim.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports